export const RESET_ADDRESS = 'RESET_ADDRESS';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_ADDRESS_VALIDITY = 'SET_ADDRESS_VALIDITY';
export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
export const SET_VISIBILITY = 'SET_VISIBILITY';
export const SET_NOT_COVERED_ADDRESS = 'SET_NOT_COVERED_ADDRESS';
export const SET_TIME_IN_COVERAGE = 'SET_TIME_IN_COVERAGE';
export const SET_COVERAGE_TYPE = 'SET_COVERAGE_TYPE';

export default {
  SET_ADDRESS,
  SET_ADDRESS_VALIDITY,
  SET_SUGGESTIONS,
  SET_VISIBILITY,
  SET_NOT_COVERED_ADDRESS,
  SET_TIME_IN_COVERAGE,
  SET_COVERAGE_TYPE
};



// WEBPACK FOOTER //
// ./src/store/modules/addresses/types.js